import type { Company } from '@/types/company'
import type { AddressComponent } from '@/types/address'

export enum UserRole {
    User = 'User',
    Organizer = 'Organizer',
    Participant = 'Participant',
}

export interface Role {
    id: number
    name: string
    type?: string
}

export interface User {
    id: number
    documentId?: string
    username: string
    email: string
    confirmed?: boolean
    emailVerifiedAt?: string | null
    role: Role
    callName?: string
    fullName?: string
    phone?: string
    pronouns?: string
    gender?: string
    birthday?: string
    address?: AddressComponent
    hasFormatNotifications?: boolean
    position?: string
}

export interface Organizer {
    id: number
    documentId?: string
    user: User | string
    company: Company | string
    role?: 'OWNER' | 'MEMBER' | 'ADMIN'
    description?: string
    createdAt: string
    updatedAt: string
    publishedAt?: string
}

export interface OrganizerStrapiResponse extends Omit<
    Organizer,
    'user' | 'company' | 'documentId'
> {
    documentId: string
    company: Company
}

export interface Participant {
    documentId: string
    id: number
    user: User
    legalGuardian: string | null
    legalGuardianEmail: string | null
    legalGuardianApprovedAt: string | null
    legalGuardianRejectedAt: string | null
    legalGuardianEmailSentAt: string | null
    createdAt?: string
    updatedAt?: string
    publishedAt?: string
}

export const USER_MUTABLE_FIELDS = [
    'username',
    'email',
    'callName',
    'fullName',
    'phone',
    'pronouns',
    'birthday',
] as const satisfies readonly (keyof User)[]

export const ORGANIZER_MUTABLE_FIELDS = [
    'company',
    'role',
    'description',
] as const satisfies readonly (keyof Organizer)[]
